import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router";
import { useWindowSize } from "../../../../../Helpers";
import { useResolvedGameData } from "../../../resolveGameData";
import Button from "@components/Button";
import "../Quiz/style.scss";
import "./style.scss";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import ArrowButton from "@components/ArrowButton";
import DOMPurify from "dompurify";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

export default function PollSlider({
  currentQuestion,
  setCurrentQuestion,
  setAnswers,
  answers,
  sendAnswers,
}) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  const swiperRef = useRef(null);
  const gameQuestionsQuery = useResolvedGameData(answers);
  const XGA = width >= 1020;
  const [selected, setSelected] = useState(-1);

  const question = gameQuestionsQuery.content[currentQuestion];
  const questionAnswers = question.answers || [];
  const initialSlide = Math.floor(questionAnswers.length / 2);

  const CheckAnswers = () => {
    const currentQuestionIdent = question.ident;
    const selectedAnswerIdent = questionAnswers[selected].ident;

    setAnswers((prevAnswers) => {
      const isQuestionAlreadyAnswered = prevAnswers.find(
        (answer) => answer.question_ident === currentQuestionIdent,
      );

      if (
        !isQuestionAlreadyAnswered &&
        (question.correctAnswer === null || selected === question.correctAnswer)
      ) {
        return [
          ...prevAnswers,
          {
            question_ident: currentQuestionIdent,
            answer_ident: selectedAnswerIdent,
          },
        ];
      }
      return prevAnswers;
    });
  };

  useEffect(() => {
    if (selected !== -1) {
      CheckAnswers();
    }
  }, [selected]);

  const handleAnswerClick = (index) => {
    setSelected(index);
    if (swiperRef.current) {
      swiperRef.current.slideTo(index);
    }
  };

  const handleNextButtonClick = () => {
    setCurrentQuestion(currentQuestion + 1);
    setSelected(-1);
    if (gameQuestionsQuery.answersNumber === answers.length) {
      sendAnswers();
    }
  };

  const nextButtonCopy = question.nextButtonCopy ?? "Abstimmen";

  return (
    <section
      className={`game-page quiz-mechanics poll-slider-mechanics ${ident}`}
    >
      <div>
        <PagesHeader back>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>
        <div className="main-game-wrppaer">
          <div className="desktop-wrapper">
            <LinearGradientProgressBar
              value={currentQuestion / gameQuestionsQuery.content.length}
            />
            <div className="game-question">
              <h2
                className="question"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(question.question),
                }}
              />
            </div>
            <div className="poll-slider-main-game-wrapper">
              <div className="poll-slider-button-prev events">
                <ArrowButton reverse />
              </div>
              <Swiper
                key={questionAnswers
                  .map((item) => `${item.ident}:${item.answer}`)
                  .join("|")}
                className="poll-slider"
                centeredSlides
                slidesPerView="auto"
                spaceBetween={0}
                initialSlide={initialSlide}
                navigation={{
                  nextEl:
                    ".poll-slider-mechanics .poll-slider-button-next.events",
                  prevEl:
                    ".poll-slider-mechanics .poll-slider-button-prev.events",
                }}
                modules={[Navigation]}
                onSwiper={(swiper) => {
                  swiperRef.current = swiper;
                }}
              >
                {questionAnswers.map((e, index) => (
                  <SwiperSlide key={e.ident || index}>
                    <div
                      className={`event-card ${
                        index === selected ? "active" : ""
                      } ${selected === -1 ? "initial" : ""}`}
                    >
                      <img
                        onClick={() => handleAnswerClick(index)}
                        alt="card-img"
                        className="card-img"
                        src={e.answer}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="poll-slider-button-next events">
                <ArrowButton />
              </div>
            </div>
            {XGA && (
              <div className="desktop-buttons">
                <Button
                  action={handleNextButtonClick}
                  disabled={selected === -1}
                >
                  {nextButtonCopy}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
      {!XGA && (
        <StickyButton
          action={handleNextButtonClick}
          disabled={selected === -1}
        >
          {nextButtonCopy}
        </StickyButton>
      )}
    </section>
  );
}
